import { Header, SideBar } from '../components';
import { useUi } from '../context/ui.context';
import { useAuth } from '../context/user.context';
import { NavigationProvider } from '../context/navigationContext';
import { getDefaultDedicatedSection, hasDedicatedServersAccess } from './dedicatedAccess';
import React, { FC, useEffect, useState, useMemo } from 'react'
import {
  PageWrapper
} from './styles'
import {
  NotFound,
  AccessDenied,
  TechBreak,
  HomePage,
  Operations,
  AccountSettings,
  BareMetal,
  CreateBareMetal,
  BareMetalPage,
  ObjectStoragePage,
  CreateBucket,
  CreateBucketRule,
  CreateBucketPolicy,
  BucketPage,
  DedicatedServers,
  DedicatedServerDetails,
  DedicatedUsers,
  DedicatedUserDetails,
  DedicatedIpAssignments,
  DedicatedIpAssignmentDetails,
  PreorderHardwarePage,
  PreorderHardwareForm,
  DedicatedPreordersPage,
  DedicatedPreorderDetails,
  DedicatedPreorderForm,
} from '../pages'
import {
  Clients,
  ClientPage,
  Users,
  UserGroups,
  ClientGroups,
  Roles,
  RolePage,
  CreateRole,
  CreateClientGroup,
  CreateClient,
  EditClient,
  CreateUser,
  EditUser,
  UserPage,
} from '../pages/clients-users';
import {
  Instances,
  Images,
  Volumes,
  CreateVolume,
  VolumeBackups,
  VolumeBackupPage,
  VolumeSnapshots,
  VolumeSnapshotPage,
  VolumeTypes,
  VolumeTypePage,
  FloatingIPs,
  Routers,
  Networks,
  Ports,
  CreatePort,
  Flavors,
  FlavorGroups,
  SecurityGroups,
  SSHKeys,
  LoadBalancers,
  Hypervisors,
  StaffObjectStorage,
} from '../pages/cloud';
import CreateFlavor from '../pages/cloud/flavors/create-flavor';
import FlavorPage from '../pages/cloud/flavors/flavor-page';
import CreateFlavorGroup from '../pages/cloud/flavors-groups/create-flavor-group';
import FlavorGroupPage from '../pages/cloud/flavors-groups/flavor-group-page';
import VolumePage from '../pages/cloud/Volumes/volume-page';
import CreateVolumeType from '../pages/cloud/VolumeTypes/create';
import EditVolumeType from '../pages/cloud/VolumeTypes/edit';
import ImagePage from '../pages/cloud/Images/image-page';
import CreateImage from '../pages/cloud/Images/create-image';
import EditImage from '../pages/cloud/Images/edit-image';
import RouterPage from '../pages/cloud/Routers/router-page';
import NetworkPage from '../pages/cloud/networks/network-page';
import CreateNetwork from '../pages/cloud/networks/create-network';
import PortPage from '../pages/cloud/Ports/port-page';
import CreateFloatingIp from '../pages/cloud/Floating-IPs/create-page';
import CreateSshKey from '../pages/cloud/Ssh-keys/create-page';
import ImportSshKey from '../pages/cloud/Ssh-keys/import-page';
import EditSshKey from '../pages/cloud/Ssh-keys/edit-ssh';
import SecurityGroupPage from '../pages/cloud/Security-groups/group-page';
import CreateSecurityGroupRule from '../pages/cloud/Security-groups/group-page/create-rule';
import CreateLoadBalancer from '../pages/cloud/Load-balancers/create-page';
import EditLoadBalancer from '../pages/cloud/Load-balancers/edit-page';
import LoadBalancerPage from '../pages/cloud/Load-balancers/lb-page';
import LoadBalancerListenerPage from '../pages/cloud/lb-listener';
import EditLoadBalancerListener from '../pages/cloud/lb-listener/components/edit-listener';
import LoadBalancerPolicyPage from '../pages/cloud/lb-listener/components/policy-page';
import CreateLoadBalancerPolicy from '../pages/cloud/lb-listener/components/create-policy';
import LoadBalancerPolicyRulePage from '../pages/cloud/lb-listener/components/rule-page';
import CreateLoadBalancerPolicyRule from '../pages/cloud/lb-listener/components/create-policy-rule';
import LoadBalancerPoolPage from '../pages/cloud/lb-pool';
import EditLoadBalancerPool from '../pages/cloud/lb-pool/components/edit-pool';
import LoadBalancerPoolMonitorPage from '../pages/cloud/lb-pool/components/monitor-page';
import CreateLoadBalancerPoolMonitor from '../pages/cloud/lb-pool/components/create-monitor';
import LoadBalancerPoolMemberPage from '../pages/cloud/lb-pool/components/member-page';
import CreateLoadBalancerPoolMember from '../pages/cloud/lb-pool/components/create-member';
import EditLoadBalancerPoolMember from '../pages/cloud/lb-pool/components/edit-member';
import ZonesList from '../pages/openstack/zones/list';
import ZoneCreate from '../pages/openstack/zones/create';
import ZoneEdit from '../pages/openstack/zones/edit';
import ZoneDetails from '../pages/openstack/zones/details';
import ProjectsList from '../pages/openstack/projects/list';
import ProjectCreate from '../pages/openstack/projects/create';
import ProjectEdit from '../pages/openstack/projects/edit';
import ProjectQuotas from '../pages/openstack/projects/quotas';
import ProjectDetails from '../pages/openstack/projects/details';
import ClustersList from '../pages/openstack/clusters/list';
import ClusterPage from '../pages/openstack/clusters/cluster-page';
import ClusterSettings from '../pages/settings/clusters';
import {
  ServicePage,
  BillingOverview,
  Services,
  Invoices,
  InvoicePage,
  InvoiceEdit,
  Journal,
  Gateways,
  GatewayPage,
  Products,
  ProductPage,
  ProductCreateEdit,
  Orders,
  OrderPage,
  OrdersCreate,
  OrderProductForm,
  OrdersCart,
  OrderUnderReview,
  TaxRules,
  ConfigOptions,
  JournalItemPage,
  JournalItemEdit,
  GatewayEdit,
  AffiliateSettings,
  CreateEditAffiliateSettings,
  AffiliateSettingsView,
  UkrsibPage,
} from '../pages/billing'
import ServiceEditForm from '../pages/billing/service-page/edit-form'
import ServiceUpgradeForm from '../pages/billing/service-page/upgrade-form'
import { InstancePage, CreateAndEditInstance } from '../pages/cloud/Instances/components';
import {Routes, Route, Navigate, useLocation} from 'react-router'
import {
  OpenStack,
  OpenStackPlans,
  Configurations,
  GeneralSettings,
  OpenstackPlanPage,
  CreateEditRule,
  CreateEditPlanPage,
  ConfigurationPage,
  MessageTemplatesList,
  MessageTemplateCreate,
  MessageTemplateEdit,
  AuthorizationSettings,
} from '../pages/settings';
import OperationPage from '../pages/utils/Operations/operation-page';
import MassMessageList from '../pages/clients-users/mass-message';
import SendMassMessage from '../pages/clients-users/mass-message/send-mass-message';
import ActivityLog from '../pages/utils/activity-log';
import EmailMessageLog from '../pages/utils/email-message-log';
import EmailMessageLogDetails from '../pages/utils/email-message-log/details';
import PeriodicTaskLogPage from '../pages/utils/periodic-task-log';
import PeriodicTaskLogDetails from '../pages/utils/periodic-task-log/task-page';
import {
  ReportsList,
  EstimatedInstanceRevenue,
  YearlyRevenue,
  RevenueReportsList,
  RevenueReportGenerate,
  RevenueReportDetails,
} from '../pages/utils/reports';
import CreateSecurityGroup from '../pages/cloud/Security-groups/create-page';
import DirectorDashboard from '../pages/analytics/DirectorDashboard';
import HypervisorPage from '../pages/cloud/Hypervisors/hypervisor-page';
// Component to handle routes under development
const UnderDevelopment: FC = () => {
  return (
    <div>
      <TechBreak message="This feature is currently under development" />
    </div>
  )
}

const RedirectWithPrefix: FC<{ prefix: string }> = ({ prefix }) => {
  const location = useLocation()

  return <Navigate replace to={`${prefix}${location.pathname}${location.search}${location.hash}`} />
}

interface MenuItem {
  label: string;
  icon: string;
  feature: string;
  angular_route: string;
  type: string;
  icon_class: string;
  href: null;
  open_in_new_tab: boolean;
  location: null;
  under_category: null;
  related_permission: string | null;
  label_with_items_count: string | null;
}

interface MenuCategory {
  category: string;
  main_feature: string;
  items: MenuItem[];
  type: string;
  location: null;
}

const hasAccess = (appMenu: any, featureToCheck: string): boolean => {
  if (!appMenu?.menu) return false;

  const hasMainFeature = appMenu.menu?.some((category: MenuCategory) =>
    category.main_feature === featureToCheck
  );
  if (hasMainFeature) return true;

  return appMenu.menu?.some((category: MenuCategory) =>
    category.items?.some((item: MenuItem) =>
      item.feature === featureToCheck
    )
  );
}

const normalizeMenuRoute = (route?: string | null) => route?.replace(/^\/+|\/+$/g, '') || ''

const hasMenuRoute = (appMenu: any, routeToCheck: string): boolean => {
  if (!appMenu?.menu) return false

  const normalizedRoute = normalizeMenuRoute(routeToCheck)
  return appMenu.menu?.some((category: MenuCategory) => {
    if (normalizeMenuRoute((category as any).angular_route) === normalizedRoute) return true

    return category.items?.some((item: MenuItem) => {
      const itemRoute = normalizeMenuRoute(item.angular_route)
      return itemRoute === normalizedRoute || itemRoute === `openstack/${normalizedRoute}`
    })
  })
}

const hasAnyAccess = (appMenu: any, features: string[], routes: string[] = []): boolean => {
  return features.some((feature) => hasAccess(appMenu, feature)) || routes.some((route) => hasMenuRoute(appMenu, route))
}

const getMenuRouteByPermission = (appMenu: any, permission: string): string => {
  if (!appMenu?.menu) return ''

  for (const menuEntry of appMenu.menu) {
    if (menuEntry.related_permission === permission) {
      return normalizeMenuRoute(menuEntry.angular_route)
    }

    const item = menuEntry.items?.find((menuItem: MenuItem) => menuItem.related_permission === permission)
    if (item) return normalizeMenuRoute(item.angular_route)
  }

  return ''
}

const getAuthorizedObjectStorageRoute = (appMenu: any, permission: string, route: string): string => {
  return getMenuRouteByPermission(appMenu, permission) || (hasMenuRoute(appMenu, route) ? route : '')
}

// --- Path components extracted outside AuthorizedRouter ---

const ClientsPath: FC<{ appMenu: any }> = ({ appMenu }) => (
  <Routes>
    {hasAccess(appMenu, 'clients&users.clients') && (
      <Route path="clients" element={<Clients />} />
    )}
    {hasAccess(appMenu, 'clients&users.clients') && (
      <>
        <Route path="clients/create" element={<CreateClient />} />
        <Route path="clients/:userId/edit" element={<EditClient />} />
        <Route path="clients/:userId/*" element={<ClientPage />} />
      </>
    )}
    {hasAccess(appMenu, 'clients&users.users') && (
      <Route path="users" element={<Users />} />
    )}
    {hasAccess(appMenu, 'clients&users.users') && (
      <>
        <Route path="users/create" element={<CreateUser />} />
        <Route path="users/:userId/edit" element={<EditUser />} />
        <Route path="users/:userId/*" element={<UserPage />} />
      </>
    )}
    {hasAccess(appMenu, 'clients&users.usergroups') && (
      <Route path="user-groups" element={<UserGroups />} />
    )}
    {hasAccess(appMenu, 'clients&users.usergroups') && (
      <Route path="user-groups/create" element={<CreateClientGroup />} />
    )}
    {hasAccess(appMenu, 'clients&users.usergroups') && (
      <Route path="user-groups/:groupId/edit" element={<CreateClientGroup />} />
    )}
    {hasAccess(appMenu, 'clients&users.clientgroups') && (
      <Route path="client-groups" element={<ClientGroups />} />
    )}
    {hasAccess(appMenu, 'clients&users.clientgroups') && (
      <Route path="client-groups/create" element={<CreateClientGroup />} />
    )}
    {hasAccess(appMenu, 'clients&users.clientgroups') && (
      <Route path="client-groups/:groupId/edit" element={<CreateClientGroup />} />
    )}
    {hasAccess(appMenu, 'clients&users.roles') && (
      <Route path="roles" element={<Roles />} />
    )}
    {hasAccess(appMenu, 'clients&users.roles') && (
      <Route path="roles/create" element={<CreateRole />} />
    )}
    {hasAccess(appMenu, 'clients&users.roles') && (
      <Route path="roles/:roleId/edit" element={<CreateRole />} />
    )}
    {hasAccess(appMenu, 'clients&users.roles') && (
      <Route path="roles/:roleId/*" element={<RolePage />} />
    )}
    {hasAccess(appMenu, 'clients&users.mass-mail') && (
      <>
        <Route path="mass-message" element={<MassMessageList />} />
        <Route path="mass-message/send-mass-message" element={<SendMassMessage />} />
      </>
    )}
    <Route path="*" element={<AccessDenied />} />
  </Routes>
)

const CloudPath: FC<{ appMenu: any }> = ({ appMenu }) => (
  <Routes>
    {hasAccess(appMenu, 'openstack.volumes.backups') && (
      <>
        <Route path="/volume-backups" element={<VolumeBackups />} />
        <Route path="/volume-backups/:backupId" element={<VolumeBackupPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.volumes.snapshots') && (
      <>
        <Route path="/volume-snapshots" element={<VolumeSnapshots />} />
        <Route path="/volume-snapshots/:snapshotId" element={<VolumeSnapshotPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.volumes.types') && (
      <>
        <Route path="/volume-types" element={<VolumeTypes />} />
        <Route path="/volume-types/create" element={<CreateVolumeType />} />
        <Route path="/volume-types/:id/edit" element={<EditVolumeType />} />
        <Route path="/volume-types/:typeId" element={<VolumeTypePage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.volumes') && (
      <>
        <Route path="/volumes" element={<Volumes />} />
        <Route path="/volumes/create" element={<CreateVolume />} />
        <Route path="/volumes/:volumeId/*" element={<VolumePage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.instances') && (
      <>
        <Route path="/instances" element={<Instances />} />
        <Route path="/instances/create" element={<CreateAndEditInstance />} />
        <Route path="/instances/:instanceId/*" element={<InstancePage />} />
      </>
    )}
    {hasAnyAccess(appMenu, ['openstack.baremetal', 'openstack.bare_metal', 'openstack.bare-metal'], ['bare-metal']) && (
      <>
        <Route path="/bare-metal" element={<BareMetal />} />
        <Route path="/bare-metal/create" element={<CreateBareMetal />} />
        <Route path="/bare-metal/:baremetalId/*" element={<BareMetalPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.images') && (
      <>
        <Route path="/images" element={<Images />} />
        <Route path="/images/create" element={<CreateImage />} />
        <Route path="/images/:imageId/edit/*" element={<EditImage />} />
        <Route path="/images/:imageId/*" element={<ImagePage />} />
      </>
    )}
    {hasAnyAccess(appMenu, ['openstack.object_store', 'openstack.obj_store', 'openstack.object-storage', 'openstack.objectstorage'], ['object-storage']) && (
      <>
        <Route path="/object-storage" element={<ObjectStoragePage />} />
        <Route path="/object-storage/create" element={<CreateBucket />} />
        <Route path="/object-storage/buckets/:bucketId/create-lifecycle-rule" element={<CreateBucketRule />} />
        <Route path="/object-storage/buckets/:bucketId/lifecycle-rules/:ruleId/edit" element={<CreateBucketRule />} />
        <Route path="/object-storage/buckets/:bucketId/policy" element={<CreateBucketPolicy />} />
        <Route path="/object-storage/buckets/:bucketId/*" element={<BucketPage />} />
        <Route path="/object-storage/*" element={<ObjectStoragePage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.floatingips') && (
      <>
        <Route path="/floating-ips" element={<FloatingIPs />} />
        <Route path="/floating-ips/create" element={<CreateFloatingIp />} />
      </>
    )}
    {hasAccess(appMenu, 'kubernetes.clusters') && (
      <>
        <Route path="/clusters" element={<ClustersList />} />
        <Route path="/clusters/:clusterId/*" element={<ClusterPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.cluster_templates') && (
      <Route path="/cluster-templates" element={<UnderDevelopment />} />
    )}
    {hasAccess(appMenu, 'openstack.dbaas') && (
      <Route path="/database-instances" element={<UnderDevelopment />} />
    )}
    {hasAccess(appMenu, 'openstack.networks') && (
      <>
        <Route path="/networks" element={<Networks />} />
        <Route path="/networks/create" element={<CreateNetwork />} />
        <Route path="/networks/:id/*" element={<NetworkPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.rbac_policies') && (
      <Route path="/rbac-policies" element={<UnderDevelopment />} />
    )}
    {hasAccess(appMenu, 'openstack.routers') && (
      <>
        <Route path="/routers" element={<Routers />} />
        <Route path="/routers/:idRouter/*" element={<RouterPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.ports') && (
      <>
        <Route path="/ports" element={<Ports />} />
        <Route path="/ports/create" element={<CreatePort />} />
        <Route path="/ports/:portId/edit" element={<CreatePort />} />
        <Route path="/ports/:portId/*" element={<PortPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.dns.zones') && (
      <>
        <Route path="/zones" element={<ZonesList />} />
        <Route path="/zones/create" element={<ZoneCreate />} />
        <Route path="/zones/:zoneId" element={<ZoneDetails />} />
        <Route path="/zones/:zoneId/edit" element={<ZoneEdit />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.projects') && (
      <>
        <Route path="/projects" element={<ProjectsList />} />
        <Route path="/projects/create" element={<ProjectCreate />} />
        <Route path="/projects/:id/edit" element={<ProjectEdit />} />
        <Route path="/projects/:id/quotas/*" element={<ProjectQuotas />} />
        <Route path="/projects/:id/*" element={<ProjectDetails />} />
      </>
    )}
    {hasAnyAccess(appMenu, ['openstack.securitygroups', 'openstack.security_groups'], ['security-groups']) && (
      <>
        <Route path="/security-groups" element={<SecurityGroups />} />
        <Route path="/security-groups/create" element={<CreateSecurityGroup />} />
        <Route path="/security-groups/:groupId/edit" element={<CreateSecurityGroup />} />
        <Route path="/security-groups/:groupId/create-rule" element={<CreateSecurityGroupRule />} />
        <Route path="/security-groups/:groupId" element={<SecurityGroupPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.subnetpools') && (
      <Route path="/subnet-pools" element={<UnderDevelopment />} />
    )}
    {hasAnyAccess(appMenu, ['openstack.flavors'], ['flavors']) && (
      <>
        <Route path="/flavor-groups" element={<FlavorGroups />} />
        <Route path="/flavor-groups/create" element={<CreateFlavorGroup />} />
        <Route path="/flavor-groups/:groupId/edit" element={<CreateFlavorGroup />} />
        <Route path="/flavor-groups/:groupId" element={<FlavorGroupPage />} />
        <Route path="/flavors" element={<Flavors />} />
        <Route path="/flavors/create" element={<CreateFlavor />} />
        <Route path="/flavors/:flavorId/edit" element={<CreateFlavor />} />
        <Route path="/flavors/:flavorId" element={<FlavorPage />} />
      </>
    )}
    {hasAnyAccess(appMenu, ['openstack.sshkeys', 'openstack.ssh_keys'], ['ssh-keys']) && (
      <>
        <Route path="/ssh-keys" element={<SSHKeys />} />
        <Route path="/ssh-keys/create" element={<CreateSshKey />} />
        <Route path="/ssh-keys/import" element={<ImportSshKey />} />
        <Route path="/ssh-keys/edit/:sshId" element={<EditSshKey />} />
      </>
    )}
    {hasAnyAccess(appMenu, ['openstack.lbaas', 'openstack.loadbalancers', 'openstack.load_balancers'], ['load-balancers']) && (
      <>
        <Route path="/load-balancers" element={<LoadBalancers />} />
        <Route path="/load-balancers/create" element={<CreateLoadBalancer />} />
        <Route path="/load-balancers/create-listener/:lbId" element={<CreateLoadBalancer />} />
        <Route path="/load-balancers/create-pool/:lbId" element={<CreateLoadBalancer />} />
        <Route path="/load-balancers/edit/:lbId" element={<EditLoadBalancer />} />
        <Route path="/load-balancer-listener/:lbId/:listenerId/edit" element={<EditLoadBalancerListener />} />
        <Route path="/load-balancer-listener/:lbId/:listenerId/policies/create" element={<CreateLoadBalancerPolicy />} />
        <Route path="/load-balancer-listener/:lbId/:listenerId/policies/:policyId/edit" element={<CreateLoadBalancerPolicy isEdit />} />
        <Route path="/load-balancer-listener/:lbId/:listenerId/policies/:policyId/rules/create" element={<CreateLoadBalancerPolicyRule />} />
        <Route path="/load-balancer-listener/:lbId/:listenerId/policies/:policyId/rules/:ruleId/edit" element={<CreateLoadBalancerPolicyRule isEdit />} />
        <Route path="/load-balancer-listener/:lbId/:listenerId/policies/:policyId/rules/:ruleId" element={<LoadBalancerPolicyRulePage />} />
        <Route path="/load-balancer-listener/:lbId/:listenerId/policies/:policyId/*" element={<LoadBalancerPolicyPage />} />
        <Route path="/load-balancer-listener/:lbId/:listenerId/*" element={<LoadBalancerListenerPage />} />
        <Route path="/load-balancer-pool/:lbId/:poolId/edit" element={<EditLoadBalancerPool />} />
        <Route path="/load-balancer-pool/:lbId/:poolId/health-monitors/create" element={<CreateLoadBalancerPoolMonitor />} />
        <Route path="/load-balancer-pool/:lbId/:poolId/health-monitors/:monitorId/edit" element={<CreateLoadBalancerPoolMonitor isEdit />} />
        <Route path="/load-balancer-pool/:lbId/:poolId/health-monitors/:monitorId" element={<LoadBalancerPoolMonitorPage />} />
        <Route path="/load-balancer-pool/:lbId/:poolId/members/create" element={<CreateLoadBalancerPoolMember />} />
        <Route path="/load-balancer-pool/:lbId/:poolId/members/:memberId/edit" element={<EditLoadBalancerPoolMember />} />
        <Route path="/load-balancer-pool/:lbId/:poolId/members/:memberId" element={<LoadBalancerPoolMemberPage />} />
        <Route path="/load-balancer-pool/:lbId/:poolId/*" element={<LoadBalancerPoolPage />} />
        <Route path="/load-balancers/:lbId/*" element={<LoadBalancerPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.hypervisors') && (
      <>
        <Route path="/hypervisors" element={<Hypervisors />} />
        <Route path="/hypervisors/:hypervisorId/*" element={<HypervisorPage />} />
      </>
    )}
    {hasAccess(appMenu, 'openstack.projects') && (
      <Route path="/projects" element={<UnderDevelopment />} />
    )}
    {hasAccess(appMenu, 'openstack.apiusers') && (
      <Route path="/api-users" element={<UnderDevelopment />} />
    )}
    <Route path="*" element={<AccessDenied />} />
  </Routes>
)

const BillingPath: FC<{ appMenu: any }> = ({ appMenu }) => (
  <Routes>
    {(hasAccess(appMenu, 'billing.overview') || hasAccess(appMenu, 'billing')) && (
      <Route path='/overview' element={<BillingOverview />}/>
    )}
    {hasAccess(appMenu, 'billing.services') && (
      <>
        <Route path='/services' element={<Services />}/>
        <Route path='/services/:serviceId' element={<ServicePage />}/>
        <Route path='/services/:serviceId/edit' element={<ServiceEditForm />}/>
        <Route path='/services/:serviceId/upgrade' element={<ServiceUpgradeForm />}/>
      </>
    )}
    {hasAccess(appMenu, 'billing.invoices') && (
      <>
        <Route path='/invoices' element={<Invoices />}/>
        <Route path='/invoices/create' element={<InvoiceEdit />}/>
        <Route path='/invoices/:invoiceId' element={<InvoicePage />}/>
        <Route path='/invoices/:invoiceId/edit' element={<InvoiceEdit />}/>
      </>
    )}
    {hasAccess(appMenu, 'billing.journal') && (
      <>
        <Route path='/journal' element={<Journal />}/>
        <Route path='/journal/:journalId' element={<JournalItemPage />}/>
        <Route path='/journal/:journalId/edit' element={<JournalItemEdit />}/>
      </>
    )}
    {hasAccess(appMenu, 'billing.gateways') && (
      <>
        <Route path='/gateways' element={<Gateways />}/>
        <Route path='/gateways/:gatewayId/*' element={<GatewayPage />}/>
        <Route path='/gateways/:gatewayId/edit' element={<GatewayEdit />}/>
      </>
    )}
    {hasAccess(appMenu, 'billing.products') && (
      <>
        <Route path='/products' element={<Products />}/>
        <Route path='/products/create' element={<ProductCreateEdit />}/>
        <Route path='/products/:productId/edit' element={<ProductCreateEdit />}/>
        <Route path='/products/:productId' element={<ProductPage />}/>
      </>
    )}
    {hasAccess(appMenu, 'billing') && (
      <Route path='/configurable-options' element={<ConfigOptions />}/>
    )}
    {hasAccess(appMenu, 'billing.taxrules') && (
      <Route path='/tax-rules' element={<TaxRules />}/>
    )}
    {hasAccess(appMenu, 'billing.referrals') && (
      <>
        <Route path='/referrals' element={<AffiliateSettings />}/>
        <Route path='/referrals/create' element={<CreateEditAffiliateSettings />}/>
        <Route path='/referrals/edit/:id' element={<CreateEditAffiliateSettings />}/>
        <Route path='/referrals/view/:id' element={<AffiliateSettingsView />}/>
      </>
    )}
    {hasAccess(appMenu, 'billing') && (
      <Route path='/ukrsib/*' element={<UkrsibPage />}/>
    )}
    <Route path="*" element={<AccessDenied />} />
  </Routes>
)

const OrdersPath: FC<{ appMenu: any }> = ({ appMenu }) => (
  <Routes>
    {hasAccess(appMenu, 'billing.orders') && (
      <>
        <Route path='/' element={<Orders />}/>
        <Route path='/create' element={<OrdersCreate />}/>
        <Route path='/create/order-product/:productCode' element={<OrderProductForm />}/>
        <Route path='/create/order-product/:productCode/:cycle' element={<OrderProductForm />}/>
        <Route path='/create/order-product/:productCode/:domainAction/:domainName' element={<OrderProductForm />}/>
        <Route path='/cart' element={<OrdersCart />}/>
        <Route path='/cart/:cartItemId' element={<OrderProductForm editMode />}/>
        <Route path='/under-review' element={<OrderUnderReview />}/>
        <Route path='/referral-review' element={<OrderUnderReview />}/>
        <Route path='/:orderId' element={<OrderPage />}/>
      </>
    )}
    <Route path="*" element={<AccessDenied />} />
  </Routes>
)

const UtilitiesPath: FC<{ appMenu: any }> = ({ appMenu }) => (
  <Routes>
    {hasAccess(appMenu, 'utils.activitylog') && (
      <Route path='/activity-log' element={<ActivityLog />}/>
    )}
    {hasAccess(appMenu, 'utils.operations') && (
      <>
        <Route path='/operations' element={<Operations />}/>
        <Route path='/operations/:operationId' element={<OperationPage />}/>
      </>
    )}
    {hasAccess(appMenu, 'utils.reports') && (
      <>
        <Route path='/reports' element={<ReportsList />}/>
        <Route path='/reports/estimated-instance-revenue' element={<EstimatedInstanceRevenue />}/>
        <Route path='/reports/yearly-revenue' element={<YearlyRevenue />}/>
        <Route path='/reports/revenue-reports' element={<RevenueReportsList />}/>
        <Route path='/reports/revenue-reports/generate' element={<RevenueReportGenerate />}/>
        <Route path='/reports/revenue-reports/:id' element={<RevenueReportDetails />}/>
      </>
    )}
    {hasAccess(appMenu, 'logger.periodic_task_log') && (
      <>
        <Route path='/periodic-task-log' element={<PeriodicTaskLogPage />}/>
        <Route path='/periodic-task-log/:taskId' element={<PeriodicTaskLogDetails />}/>
      </>
    )}
    {hasAccess(appMenu, 'logger.email-message-log') && (
      <>
        <Route path='/email-message-log' element={<EmailMessageLog />}/>
        <Route path='/email-message-log/:logId' element={<EmailMessageLogDetails />}/>
      </>
    )}
    <Route path="*" element={<AccessDenied />} />
  </Routes>
)

const SettingsPath: FC<{ appMenu: any }> = ({ appMenu }) => (
  <Routes>
    {hasAccess(appMenu, 'settings.general') && (
      <Route path='/general/*' element={<GeneralSettings />}/>
    )}
    {hasAccess(appMenu, 'settings.configurations') && (
      <>
        <Route path='/configurations' element={<Configurations />}/>
        <Route path='/configurations/:configurationId/*' element={<ConfigurationPage />}/>
      </>
    )}
    {hasAccess(appMenu, 'settings.authorization') && (
      <Route path='/authorization/*' element={<AuthorizationSettings />}/>
    )}
    {hasAccess(appMenu, 'settings.message_templates') && (
      <>
        <Route path='/message-templates' element={<MessageTemplatesList />}/>
        <Route path='/message-templates/create' element={<MessageTemplateCreate />}/>
        <Route path='/message-templates/:templateId/edit' element={<MessageTemplateEdit />}/>
      </>
    )}
    {hasAccess(appMenu, 'openstack.settings') && (
      <Route path='/openstack/*' element={<OpenStack />}/>
    )}
    {hasAccess(appMenu, 'kubernetes.clusters') && (
      <Route path='/clusters/*' element={<ClusterSettings />}/>
    )}
    {hasAccess(appMenu, 'openstack.plans') && (
      <>
        <Route path='/openstack-plans' element={<OpenStackPlans />}/>
        <Route path='/openstack-plans/plan/:planId/edit' element={<CreateEditPlanPage />}/>
        <Route path='/openstack-plans/plan/create' element={<CreateEditPlanPage />}/>
        <Route path='/openstack-plans/plan/:planId' element={<OpenstackPlanPage />}/>
        <Route path='/openstack-plans/rule/:ruleId/edit' element={<CreateEditRule />}/>
        <Route path='/openstack-plans/plan/:planId/create-rule' element={<CreateEditRule />}/>
      </>
    )}
    <Route path="*" element={<AccessDenied />} />
  </Routes>
)

// --- Main router ---

const AuthorizedRouter: FC = () => {
  const { smallBar } = useUi()
  const { user, appMenu } = useAuth()
  if(!appMenu)return null
  const objectStorageBucketRoute = getAuthorizedObjectStorageRoute(
    appMenu,
    'object-storage.list',
    'openstack/object-storage/storage',
  )
  const objectStorageUserRoute = getAuthorizedObjectStorageRoute(
    appMenu,
    'object-storage.users.list',
    'openstack/object-storage/users',
  )
  const canViewDedicatedServers = hasDedicatedServersAccess(appMenu, 'servers')
  const canViewDedicatedUsers = hasDedicatedServersAccess(appMenu, 'users')
  const canViewDedicatedIps = hasDedicatedServersAccess(appMenu, 'ips')
  const canViewDedicatedPreorders = hasDedicatedServersAccess(appMenu, 'preorders')
  const canViewPreorderHardware = hasDedicatedServersAccess(appMenu, 'preorder/hardware')
  const defaultDedicatedSection = getDefaultDedicatedSection(appMenu)

  return (
    <NavigationProvider>
    <div style={{ display: 'flex', minHeight: '100vh', width: '100%', minWidth: 0 }}>
      <SideBar />
      <PageWrapper isSmall={smallBar}>
        <Header/>
        <Routes>
          <Route path="/" element={<Navigate replace to="/home" />} />
          <Route path='/not-found' element={<NotFound />} />
          <Route path='/403' element={<AccessDenied />} />
          <Route path="/home" element={<HomePage />} />
          {/* The dashboard verifies its own analytics permissions with the backend. */}
          <Route path="/analytics/dashboard" element={<DirectorDashboard />} />
          {hasAccess(appMenu, 'core') && (
            <>
              <Route path="/clients-users/*" element={<ClientsPath appMenu={appMenu} />} />
              <Route path="/clients/*" element={<RedirectWithPrefix prefix="/clients-users" />} />
              <Route path="/users/*" element={<RedirectWithPrefix prefix="/clients-users" />} />
              <Route path="/user-groups/*" element={<RedirectWithPrefix prefix="/clients-users" />} />
              <Route path="/client-groups/*" element={<RedirectWithPrefix prefix="/clients-users" />} />
              <Route path="/roles/*" element={<RedirectWithPrefix prefix="/clients-users" />} />
              <Route path="/mass-message/*" element={<RedirectWithPrefix prefix="/clients-users" />} />
            </>
          )}
          <Route path="/account-settings/*" element={<AccountSettings />} />
          {defaultDedicatedSection && (
            <Route
              path="/dedicated-servers"
              element={<Navigate replace to={`/dedicated-servers/${defaultDedicatedSection}`} />}
            />
          )}
          {canViewDedicatedServers && (
            <>
              <Route path="/dedicated-servers/servers" element={<DedicatedServers />} />
              <Route path="/dedicated-servers/servers/:serverId" element={<DedicatedServerDetails />} />
            </>
          )}
          {canViewDedicatedUsers && (
            <>
              <Route path="/dedicated-servers/users" element={<DedicatedUsers />} />
              <Route path="/dedicated-servers/users/:userId" element={<DedicatedUserDetails />} />
            </>
          )}
          {canViewDedicatedIps && (
            <>
              <Route path="/dedicated-servers/ips" element={<DedicatedIpAssignments />} />
              <Route path="/dedicated-servers/ips/:assignmentId" element={<DedicatedIpAssignmentDetails />} />
            </>
          )}
          {canViewDedicatedPreorders && (
            <>
              <Route path="/dedicated-servers/preorders" element={<DedicatedPreordersPage />} />
              <Route path="/dedicated-servers/preorders/:preorderId" element={<DedicatedPreorderDetails />} />
              <Route path="/dedicated-servers/preorders/:preorderId/edit" element={<DedicatedPreorderForm />} />
            </>
          )}
          {canViewPreorderHardware && (
            <>
              <Route path="/dedicated-servers/preorder/hardware" element={<PreorderHardwarePage />} />
              <Route path="/dedicated-servers/preorder/hardware/:hardwareType/create" element={<PreorderHardwareForm />} />
              <Route path="/dedicated-servers/preorder/hardware/:hardwareType/:hardwareId/edit" element={<PreorderHardwareForm />} />
            </>
          )}
          {objectStorageBucketRoute && (
            <Route
              path={`/${objectStorageBucketRoute}/*`}
              element={(
                <StaffObjectStorage
                  section="storage"
                  bucketListPath={`/${objectStorageBucketRoute}`}
                  userListPath={objectStorageUserRoute ? `/${objectStorageUserRoute}` : undefined}
                />
              )}
            />
          )}
          {objectStorageUserRoute && (
            <Route
              path={`/${objectStorageUserRoute}/*`}
              element={(
                <StaffObjectStorage
                  section="users"
                  userListPath={`/${objectStorageUserRoute}`}
                />
              )}
            />
          )}
          {hasAccess(appMenu, 'openstack') && (
            <>
              <Route path="/openstack/*" element={<CloudPath appMenu={appMenu} />} />
              <Route path="/volume-backups/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/volume-snapshots/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/volume-types/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/volumes/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/instances/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/bare-metal/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/images/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/object-storage/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/floating-ips/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/clusters/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/cluster-templates/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/database-instances/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/networks/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/rbac-policies/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/routers/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/ports/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/zones/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/projects/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/security-groups/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/subnet-pools/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/flavor-groups/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/flavors/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/ssh-keys/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/hypervisors/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/api-users/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/load-balancers/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/load-balancer-listener/*" element={<RedirectWithPrefix prefix="/openstack" />} />
              <Route path="/load-balancer-pool/*" element={<RedirectWithPrefix prefix="/openstack" />} />
            </>
          )}
          {hasAccess(appMenu, 'billing') && (
            <>
              <Route path="/billing/*" element={<BillingPath appMenu={appMenu} />} />
              <Route path="/orders/*" element={<OrdersPath appMenu={appMenu} />} />
              <Route path="/overview/*" element={<RedirectWithPrefix prefix="/billing" />} />
              <Route path="/services/*" element={<RedirectWithPrefix prefix="/billing" />} />
              <Route path="/invoices/*" element={<RedirectWithPrefix prefix="/billing" />} />
              <Route path="/journal/*" element={<RedirectWithPrefix prefix="/billing" />} />
              <Route path="/gateways/*" element={<RedirectWithPrefix prefix="/billing" />} />
              <Route path="/products/*" element={<RedirectWithPrefix prefix="/billing" />} />
              <Route path="/configurable-options/*" element={<RedirectWithPrefix prefix="/billing" />} />
              <Route path="/tax-rules/*" element={<RedirectWithPrefix prefix="/billing" />} />
              <Route path="/referrals/*" element={<RedirectWithPrefix prefix="/billing" />} />
              <Route path="/ukrsib/*" element={<RedirectWithPrefix prefix="/billing" />} />
            </>
          )}
          {hasAccess(appMenu, 'utils') && (
            <>
              <Route path="/utilities/*" element={<UtilitiesPath appMenu={appMenu} />} />
              <Route path="/activity-log/*" element={<RedirectWithPrefix prefix="/utilities" />} />
              <Route path="/operations/*" element={<RedirectWithPrefix prefix="/utilities" />} />
              <Route path="/reports/*" element={<RedirectWithPrefix prefix="/utilities" />} />
              <Route path="/periodic-task-log/*" element={<RedirectWithPrefix prefix="/utilities" />} />
              <Route path="/email-message-log/*" element={<RedirectWithPrefix prefix="/utilities" />} />
            </>
          )}
          {hasAccess(appMenu, 'settings') && (
            <>
              <Route path="/settings/*" element={<SettingsPath appMenu={appMenu} />} />
              <Route path="/general/*" element={<RedirectWithPrefix prefix="/settings" />} />
              <Route path="/configurations/*" element={<RedirectWithPrefix prefix="/settings" />} />
              <Route path="/authorization/*" element={<RedirectWithPrefix prefix="/settings" />} />
              <Route path="/message-templates/*" element={<RedirectWithPrefix prefix="/settings" />} />
              <Route path="/openstack-plans/*" element={<RedirectWithPrefix prefix="/settings" />} />
            </>
          )}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </PageWrapper>
    </div>
    </NavigationProvider>
  )
}

export default AuthorizedRouter
